/* @flow */

import Immutable from 'immutable';
import { bindSelectors, memoizeSelectors } from './selectors';

const Selectors = {
  getDataset(state: Immutable.Map, ownerId: string, datasetId: string): Immutable.Map {
    return state.getIn(['datasets', ownerId, datasetId]);
  },
  hasDatasetLoaded(state: Immutable.Map, ownerId: string, datasetId: string): boolean {
    return state.getIn(['datasets', ownerId, datasetId], null) !== null;
  },
  getDatasetStatus(state: Immutable.Map, ownerId: string, datasetId: string): boolean {
    return state.getIn(['status', ownerId + "_" + datasetId], false);
  },
  getDatasetFeatureById(state: Immutable.Map, id: string): object {
    let matched = [];

    state.get('datasets').forEach(owner => {
      owner.forEach(dataset => {
        matched = matched.concat(dataset.get('features').filter(function(record) {
          return record.id == id;
        }));
      });
    });

    return matched;
  }
};

const UnboundDatasetSelectors = memoizeSelectors(Selectors);
const DatasetSelectors = bindSelectors('dataset', UnboundDatasetSelectors);

export {
  DatasetSelectors,
  UnboundDatasetSelectors
};
